import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import AuthContext from "../../auth/index";
import Layout from "../components/structure/Layout";
import Forbidden from "../../pages/forbidden/forbidden";
import Dashboard from "../pages/Dashboard";
import Reports from "../pages/Reports";
import Functionalities from "../pages/Functionalities";
import Notifications from "../pages/Notifications";
import Home from "../pages/Home";
import ControlTables from "../pages/ControlTables";
import { hasAdminRole, hasGestorSSERole } from "../../utils/hasPermission";

const PrivateRoute = ({
  component: Component,
  layout: Layout,
  roles = [],
  isPublicAccess = false,
  allowAccessGestorSSE = false,
  ...rest
}) => {
  const { authenticated} = useContext(AuthContext);

  const [permission, setPermission] = useState(null);

  useEffect(() => {

    const loadPermissions = async () => {
      try {
        const isAdmin = await hasAdminRole()
        const isGestorSSE = await hasGestorSSERole()
        if (!authenticated) {
          setPermission(false);
        } else {
          const hasPermission = isAdmin || (allowAccessGestorSSE && isGestorSSE);
          setPermission(hasPermission);
        }
      } catch (error) {
        console.error("Error fetching permission:", error);
        setPermission(false);
      }
    };
    authenticated && loadPermissions();
  }, [authenticated, allowAccessGestorSSE]);

  if (permission === null && !isPublicAccess) {
    return null;
  }

  if ((authenticated && isPublicAccess) || permission) {
    return (
      <Route
        {...rest}
        render={(props) => (
          <Layout>
            <Component {...props} />
          </Layout>
        )}
      />
    );
  } else {
    return (
      <Route
        {...rest}
        render={(props) => (
          <Redirect
            to={{
              pathname: "/forbidden",
              state: { redirectTo: props.location },
            }}
          />
        )}
      />
    );
  }
};

const PublicRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <AuthContext.Consumer>
    {({ keycloak }) => {
      return (
        <Route
          {...rest}
          render={(props) => (
            <Layout authenticated={keycloak.authenticated}>
              <Component {...props} authenticated={keycloak.authenticated} />
            </Layout>
          )}
        />
      );
    }}
  </AuthContext.Consumer>
);

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <PublicRoute exact path="/" layout={Home} component={() => {}} />

      <PublicRoute
        exact
        path="/forbidden"
        layout={Layout}
        component={Forbidden}
      />

      <PrivateRoute
        path="/dashboard"
        layout={Layout}
        component={Dashboard}
        isPublicAccess={true}
        allowAccessGestorSSE={true}
      />

      <PrivateRoute
        path="/reports"
        layout={Layout}
        component={Reports}
        isPublicAccess={true}
        allowAccessGestorSSE={true}
      />

      <PrivateRoute
        path="/funcionalidades"
        layout={Layout}
        component={Functionalities}
      />

      <PrivateRoute
        path="/notificacoes"
        layout={Layout}
        component={Notifications}
      />

      <PrivateRoute
        path="/tabelas-de-controle/:tabela/:id/edit"
        layout={Layout}
        component={ControlTables}
        allowAccessGestorSSE={true}
      />

      <PrivateRoute
          path="/tabelas-de-controle/:tabela/:id/copy"
          layout={Layout}
          component={ControlTables}
          allowAccessGestorSSE={true}
      />

      <PrivateRoute
        path="/tabelas-de-controle/:tabela/create"
        layout={Layout}
        component={ControlTables}
        allowAccessGestorSSE={true}
      />

      <PrivateRoute
        path="/tabelas-de-controle"
        layout={Layout}
        component={ControlTables}
        allowAccessGestorSSE={true}
      />

      <Redirect to="/" />
    </Switch>
  </BrowserRouter>
);

export default Routes;
